import React, { useLayoutEffect, useState } from "react"
import PropTypes from "prop-types"
import cn from "classnames"
import hljs from "highlight.js/lib/core"

// TODO: make these import dynamic, so that different languages && themes can
//  be chosen via contentful settings
import javascript from "highlight.js/lib/languages/javascript"
hljs.registerLanguage("javascript", javascript)
import "highlight.js/styles/github-dark.css"

import Section from "../components/section"

import * as codeSnippetStyles from "./code-snippet-block.module.css"

import CopyIcon from "../images/copy.svg"
import { isClient } from "../common/utils"

const CodeSnippetBlock = ({ data }) => {
  const [hasCopiedToClipboard, setHasCopiedToClipboard] = useState(false)
  const displayedLanguage = data.language[0]
  const highlightedCode = hljs.highlight(data?.code?.code, {
    language: displayedLanguage,
  }).value

  const [isClipboardWritable] = useState(
    isClient() && navigator?.clipboard?.writeText !== undefined
  )

  useLayoutEffect(() => {
    let timeOutId
    if (hasCopiedToClipboard) {
      timeOutId = setTimeout(() => setHasCopiedToClipboard(false), 1000)
    }
    return () => {
      clearTimeout(timeOutId)
    }
  })

  const onCopyToClipboardClick = async () => {
    if (isClipboardWritable) {
      try {
        await navigator.clipboard.writeText(data.code.code)
        setHasCopiedToClipboard(true)
      } catch (e) {
        console.error("Error copying code to clipboard", e)
      }
    }
  }

  return (
    <Section>
      <div className={codeSnippetStyles.content}>
        <pre className={codeSnippetStyles.codeSnippet__container}>
          <code
            className={cn("hljs", `language-${displayedLanguage}`)}
            dangerouslySetInnerHTML={{ __html: highlightedCode }}
          />
          {isClipboardWritable && hasCopiedToClipboard && (
            <span className={codeSnippetStyles.codeSnippet__copyCodeSuccess}>
              Copied
            </span>
          )}
          {isClipboardWritable && (
            <button
              className={codeSnippetStyles.codeSnippet__copyCodeButton}
              onClick={onCopyToClipboardClick}
            >
              <img src={CopyIcon} alt="Copy code snippet into clipboard " />
            </button>
          )}
        </pre>
        {data?.caption?.length > 0 && (
          <p className={codeSnippetStyles.codeSnippet__caption}>
            {data.caption}
          </p>
        )}
      </div>
    </Section>
  )
}

CodeSnippetBlock.propTypes = {
  data: PropTypes.shape({
    caption: PropTypes.string,
    language: PropTypes.arrayOf(PropTypes.string),
    code: PropTypes.shape({ code: PropTypes.string }).isRequired,
    theme: PropTypes.string,
  }),
}

CodeSnippetBlock.defaultProps = {
  data: {
    caption: "",
    language: ["javascript"],
    theme: "GithubDark",
  },
}

export default CodeSnippetBlock
